module.exports = __webpack_public_path__ + "static/media/loader.62789a21.svg";